import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { AuthContextTwo } from "../../contexts/AuthProviderTwo";
import Loading from "../Shared/Loading/Loading";

const SignUpTutors = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const { createUser, updateUser } = useContext(AuthContextTwo);
  const [signUpError, setSignUPError] = useState("");
  const [createdUserEmail, setCreatedUserEmail] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const password = watch("password", "");

  const handleSignUp = (data) => {
    setSignUPError("");
    setIsLoading(true);
    window.fbq("track", "Lead");

    createUser(data.email, data.password)
      .then((result) => {
        const user = result.user;
        console.log(user);
        toast("User Created Successfully.");
        const userInfo = {
          displayName: data.name,
        };
        return updateUser(userInfo); // Return this promise to chain the next .then()
      })
      .then(() => {
        saveUser(data.name, data.email, data.phone);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setSignUPError(error.message);
      })
      .finally(() => {
        setIsLoading(false); // Ensure isLoading is set to false in both success and error cases
      });
  };

  const saveUser = (name, email, phone) => {
    const user = { name, email, phone };
    fetch("https://tutor-tree-server-1.vercel.app/userTutor", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then((data) => {
        setCreatedUserEmail(email);
        navigate("/dashboardTwo/tutorProfile");
      });
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordTwo, setShowPasswordTwo] = useState(false);

  return (
    <div className=" flex justify-center items-center">
      
      <div className="lg:w-[664px] sm:w-[350px] ">
        <h2 className="text-xl text-center tittleSingIn">Tutor Sign Up</h2>
        <form onSubmit={handleSubmit(handleSignUp)}>
          <div className="form-control w-full ">
            <label className="label">
              {" "}
              <span className="label-textSignIn">Name</span>
            </label>
            <input
              type="text"
              {...register("name", {
                required: "Name is Required",
              })}
              className="input border-green-400 border-2 input-bordered w-full focus:border-2 focus:border-orange-500"
            />
            {errors.name && (
              <p className="text-red-500">{errors.name.message}</p>
            )}
          </div>
          <div className="grid grid-cols-2 gap-5">
            <div className="form-control w-full ">
              <label className="label">
                {" "}
                <span className="label-textSignIn">Phone</span>
              </label>
              <input
                type="number"
                {...register("phone", {
                  required: true,
                })}
                className="input border-green-400 border-2 input-bordered w-full focus:border-2 focus:border-orange-500"
              />
              {errors.phone && (
                <p className="text-red-500">{errors.phone.message}</p>
              )}
            </div>
            <div className="form-control w-full ">
              <label className="label">
                {" "}
                <span className="label-textSignIn">Email</span>
              </label>
              <input
                type="email"
                {...register("email", {
                  required: true,
                  pattern: {
                    value: /^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                    message: "Please enter a valid email address",
                  },
                })}
                className="input border-green-400 border-2 input-bordered w-full focus:border-2 focus:border-orange-500"
              />
              {errors.email && (
                <p className="text-red-500">{errors.email.message}</p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5">
            <div className="form-control w-full relative">
              <label className="label">
                {" "}
                <span className="label-textSignIn">Password</span>
              </label>
              <input
                type={showPassword ? "text" : "password"}
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 6,
                    message: "Password must be 6 characters long",
                  },
                })}
                className="input border-green-400 border-2 input-bordered w-full focus:border-2 focus:border-orange-500"
              />
              {errors.password && (
                <p className="text-red-500">{errors.password.message}</p>
              )}

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute translate-y-12 py-1 right-3 px-1 text-sm font-medium leading-5 text-gray-700 bg-white rounded-r-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5">
                {showPassword ? "Hide" : "Show"} 
              </button>
            </div>
            <div className="form-control w-full relative">
              <label className="label">
                {" "}
                <span className="label-textSignIn">Confirm Password</span>
              </label>
              <input
                type={showPasswordTwo ? "text" : "password"}
                {...register("confirmPassword", {
                  required: "Confirm Password is required",
                  validate: (value) =>
                    value === password || "Passwords do not match",
                })}
                className="input border-green-400 border-2 input-bordered w-full focus:border-2 focus:border-orange-500"
              />
              {errors.confirmPassword && (
                <p className="text-red-500 ">
                  {errors.confirmPassword.message}
                </p>
              )}
                <button
                type="button"
                onClick={() => setShowPasswordTwo(!showPasswordTwo)}
                className="absolute translate-y-12 py-1 right-3 px-1 text-sm font-medium leading-5 text-gray-700 bg-white rounded-r-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5">
                {showPasswordTwo ? "Hide" : "Show"} 
              </button>
            </div>
          </div>
          <div className="flex sm:flex-col lg:flex-row lg:justify-between mt-5">
            <div className="flex justify-center items-center">
              <label>
                <input
                  type="checkbox"
                  className="checkBoxCol border-orange-500 border-2 focus:ring-orange-500 "
                  {...register("confirm", {
                    required: "Confirm Checkbox",
                  })}
                />
              </label>
              <h1 className="ml-2 textLinkHeading">
                I agree to the{" "}
                <Link className="textLink" to="/privacyPolicy">
                  Terms of Use and Privacy Policy
                </Link>
              </h1>
            </div>
            <div>
              <p className="textLinkHeading">
                Already have an account{" "}
                <Link className="textLink" to="/login">
                  Please Login
                </Link>
              </p>
            </div>
          </div>
          {/* Render the button or loader based on the loading state */}
          {isLoading ? (
            <div className='mt-5 bg-green-700 cursor-pointer hover:bg-green-900 duration-300 text-white font-jost text-2xl py-4 w-full rounded-lg'>
              <Loading></Loading>
            </div>
          ) : (
            <input
              className='mt-5 bg-green-700 cursor-pointer hover:bg-green-900 duration-300 text-white font-jost text-2xl py-4 w-full rounded-lg'
              value="Sign Up"
              type="submit"
            />
          )}

          {signUpError && <p className="text-red-600">{signUpError}</p>}
        </form>
      </div>
    </div>
  );
};

export default SignUpTutors;
